import React from "react";
import EventCard from "./eventCard";
import Slider from "react-slick";

const EventsList = ({ events }: any) => {
  console.log("EVENTS: ");
  console.log(events);
  const sliderSettings = {
    adaptiveHeight: false,
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 2048,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="flex-row h-32 block">
      {events.length === 0 ? (
        <div className="h-full mt-64 rounded-lg mx-auto w-1/2 p-10">
          <p className="text-gray-600">
            I server Webtic non rispondono o nessun evento è in programmazione.
          </p>
        </div>
      ) : (
        <Slider {...sliderSettings}>
          {events.map((event: any) => {
            console.log(event.title + " - " + event.hostId);
            if (event.hostId === "5409") {
              return <EventCard key={event.eventId} event={event} />;
            } else {
              return null;
            }
          })}
        </Slider>
      )}
    </div>
  );
};

export default EventsList;
